export const SAVE_HISTORY_ITEMS = 'searchbar/SAVE_HISTORY_ITEMS'
